
import React, { useState } from "react";
import { useRoleVerify } from "Common/RoleVerify";
import { GetAll, Delete } from "adminApi/RoomFeatureApi/RoomFeature";
import DataTable from "Common/DataTable/DataTable";
import usePaginatedFetch from "Hooks/usePaginatedFetch";
import useTableConfig from "Hooks/useTableConfig";
import useDebouncedValue from "Common/DataTable/useDebouncedValue";
import { generateDisplayFields } from "utils/fieldMapper";
import { FilterStatus } from "utils/FilterStatus";
import fields from "../../json/RoomFeatureFields.json";

const RoomFeatureListTable = () => {
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const debouncedSearch = useDebouncedValue(search, 500);
  const canShowAction = useRoleVerify("", ["can_edit", "can_delete"]);
  const sizeOptions = [10, 20, 50, 100];
  const { tabledata } = fields;

  // ✅ Fetch data
  const { data, meta, loading, error, refetch } = usePaginatedFetch(GetAll, {
    page,
    limit,
    search: debouncedSearch,
    title: "Room Feature List",
  });

  // ✅ Auto-generate display fields
  const displayFields = generateDisplayFields(tabledata);

  // ✅ Filtered data
  const filteredData = FilterStatus(data);

  // ✅ Table Config
  const { formattedData, columns } = useTableConfig({
    data: filteredData,
    page,
    limit,
    canShowAction,
    refetch,
    config: {
      entityName: "Room Feature",
      editUrl: "edit-room-features",
      idKey: "id",
      deleteApi: Delete,
      displayFields,
    },
  });

  // ✅ Handlers
  const handleSearch = (val, resetPage = null) => {
    setSearch(val);
    if (resetPage !== null) setPage(resetPage);
  };

  const onPageChange = (p) => setPage(p);
  const onLimitChange = (newLimit) => {
    setLimit(newLimit);
    setPage(1);
  };

  return (
    <DataTable
      columns={columns}
      data={formattedData}
      options={{
        loading,
        error,
        sortableColumns: displayFields.map((f) => f.accessor),
      }}
      Search={{
        search: true,
        SearchInputValue: search,
        handleSearch: handleSearch,
      }}
      Entries={{
        Entries: true,
        limit,
        onLimitChange,
        options: sizeOptions,
      }}
      pagination={{
        isActive: true,
        meta,
        onPageChange,
      }}
    />
  );
};

export default RoomFeatureListTable;
